import JSONApiClient from '../jsonapi-service';

export function getOrganisationByName(organisationName, currntUserName) {

  const client = JSONApiClient();

  return client.find('organisations', { filter: { name: `~${organisationName}` } })
    .then(response => {

      if (response.length > 0) {
        return response[0];
      } else {
        const organisation = client.create('organisations');
        organisation.set('name', organisationName);
        organisation.set('description', `Created by ${currntUserName}`);
        return organisation.sync()
          .then(response => {
            return response;
          });
      }
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/organisations.js
 **/